import React from 'react';

import { ContactLink } from './Contact.styled';
import { Tooltip } from 'components/v2/Tooltip/Tooltip';
import { Text } from 'components/v2/Typography/Text';

type Size = 'sm' | 'md';

type Props = {
  tooltip: string;
  minWidth?: string;
  href: string;
  icon: React.ReactNode;
  iconColor?: string;
  text?: string;
  textColor?: string;
  linkText: string;
  linkColor?: string;
  textSize: Size;
};

export const InformationContainerWithTooltip: React.FC<Props> = ({
  tooltip,
  minWidth,
  href,
  icon,
  iconColor,
  text,
  textColor,
  linkText,
  linkColor,
  textSize
}) => {
  return (
    <Text size={textSize} fontStyle="regular">
      <ContactLink $iconColor={iconColor} $linkColor={linkColor} $textColor={textColor}>
        {icon}
        <span>{text}</span>
        <Tooltip tooltip={tooltip} displayTooltip={true} minWidth={minWidth}>
          <strong>
            <a href={href}>{linkText}</a>
          </strong>
        </Tooltip>
      </ContactLink>
    </Text>
  );
};
